import React, { Fragment, useCallback, useEffect, useRef } from 'react';
import { FormikProvider, useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';

import { fetchDrafts, setMyFilter, setDraftFilteredStatus } from '../../../store/drafts';
import { renderHeadCells } from './renderHeadCells';
import { LodashHelper } from '../../../utils';
import { useFilterFormikReduxSync } from '../../../hooks/useFilterFormikReduxSync';
import { useFilterStatusHandler } from '../../../hooks/useFilterStatusHandler';
import { Navigation } from '../../../utils/navigation';

export const renderTableHead = (isUberEligible) => () => {
  const filtered = useSelector((state) => state.drafts.filtered);
  const navigate = Navigation();
  const myFilterParams = useSelector((state) => state.drafts.myFilterParams);
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: myFilterParams,
    enableReinitialize: true,
  });

  const { onClose } = useFilterStatusHandler(myFilterParams, formik?.values, setDraftFilteredStatus);

  useFilterFormikReduxSync(formik, myFilterParams, dispatch, setMyFilter);

  const fetchDraftsData = useCallback(() => dispatch(fetchDrafts({ filtered: true, Navigation: navigate })),
    [dispatch, navigate]);
  const debounceLoadData = useRef(LodashHelper.debounce((values) => fetchDraftsData(values), 1000)).current;

  useEffect(() => {
    if (filtered) {
      debounceLoadData();
    }
    return;
  }, [formik.values, filtered, debounceLoadData]);

  return (
    <FormikProvider value={formik}>
      <thead className='ant-table-thead'>
        <tr>
          {renderHeadCells({
            values: formik.values,
            setFieldValue: formik.setFieldValue,
            onClose,
            isUberEligible
          }).map((c) => (
            <Fragment key={c.title}>{c.Component}</Fragment>
          ))}
        </tr>
      </thead>
    </FormikProvider>
  );
};
